import React from 'react';
import connect from 'react-redux/lib/connect/connect';
import { citiesSelector } from '../../redux/cities/selector';
import ErrorList from '../../components/ErrorList';

const FleetScreen = ({ fleetList, onSelectFleet, selectedFleet, errors }) => {
    const isSelected = fleetId => selectedFleet === fleetId;

    return (
        <div className="container-fluid wrapper">
            <div className="page__title">{window.VULOG_TRANSLATE('Select your fleet')}</div>

            {window.VULOG_CONFIG.ERROR_DISPLAY_TOP && <ErrorList errors={errors} />}
            {fleetList.map(fleet => (
                <label
                    className={isSelected(fleet.value) ? 'city border border-primary p-2 mt-2' : 'city border p-2 mt-2'}
                    key={fleet.value}
                    htmlFor={fleet.value}
                >
                    <input
                        className="form-check-input city__input"
                        type="radio"
                        name="plan"
                        id={fleet.value}
                        value={fleet.value}
                        checked={isSelected(fleet.value)}
                        aria-label={fleet.value}
                        onChange={() => onSelectFleet(fleet.value)}
                    />
                    {fleet.label}
                </label>
            ))}

            {!window.VULOG_CONFIG.ERROR_DISPLAY_TOP && <ErrorList errors={errors} />}
        </div>
    );
};

const mapStateToProps = state => ({
    cities: citiesSelector(state),
});

export default connect(mapStateToProps, null)(FleetScreen);
